export default {
    metaInfo() {
        return {
            title: _.get(this.$page, 'meta.title', 'MMCTS'),
        }
    },
}
